import { useState, useEffect } from "react";
import { isStandalone, isMobile, getPlatform } from "../utils/platform";
import { BeforeInstallPromptEvent } from "../types";

export function usePWA() {
  const [installEvt, setInstallEvt] = useState<BeforeInstallPromptEvent | null>(null);
  const [isInstalled, setIsInstalled] = useState<boolean>(false);
  const [toast, setToast] = useState<string | null>(null);
  const [showInstallHelp, setShowInstallHelp] = useState<boolean>(false);

  // --- Install prompt wiring + 🌈 confetti ---
  useEffect(() => {
    const onBIP = (e: Event) => {
      e.preventDefault?.();
      setInstallEvt(e as BeforeInstallPromptEvent);
    };
    const onInstalled = () => {
      setIsInstalled(true);
      setToast("All set! Find BlinkBli on your Home Screen ✨");
      try {
        const el = document.createElement("div");
        el.style.position = "fixed";
        el.style.inset = "0";
        el.style.pointerEvents = "none";
        el.style.zIndex = "2147483647";
        document.body.appendChild(el);
        for (let i = 0; i < 6; i++) {
          const dot = document.createElement("div");
          dot.style.position = "absolute";
          dot.style.left = Math.random() * 100 + "vw";
          dot.style.top = "0";
          dot.style.width = "8px";
          dot.style.height = "8px";
          dot.style.borderRadius = "50%";
          dot.style.background = "white";
          dot.style.opacity = "0.9";
          dot.style.transition = "transform 600ms ease-out, opacity 600ms ease-out";
          el.appendChild(dot);
          requestAnimationFrame(() => {
            dot.style.transform = `translateY(70vh)`;
            dot.style.opacity = "0";
          });
        }
        setTimeout(() => document.body.removeChild(el), 700);
      } catch {}
    };
    setIsInstalled(isStandalone());
    window.addEventListener("beforeinstallprompt", onBIP as any);
    window.addEventListener("appinstalled", onInstalled);
    return () => {
      window.removeEventListener("beforeinstallprompt", onBIP as any);
      window.removeEventListener("appinstalled", onInstalled);
    };
  }, []);

  // Toast auto-hide
  useEffect(() => {
    if (!toast) return;
    const t = setTimeout(() => setToast(null), 1700);
    return () => clearTimeout(t);
  }, [toast]);

  async function promptInstall() {
    if (!installEvt) return;
    await installEvt.prompt();
    const choice = await installEvt.userChoice;
    if (choice.outcome === "accepted") setToast("Installing…");
    setInstallEvt(null);
  }

  const showInstallBtn = !isInstalled && isMobile() && !!installEvt;
  const showHelpBtn = !isInstalled && isMobile();
  const { isIOS, isAndroid } = getPlatform();

  return {
    installEvt,
    isInstalled,
    toast,
    setToast,
    showInstallHelp,
    setShowInstallHelp,
    showInstallBtn,
    showHelpBtn,
    isIOS,
    isAndroid,
    promptInstall
  };
}
